import { CSS } from '@grupoboticario/flora-react'

export const labelCss: CSS = {
  color: '$nonInteractiveAuxiliar'
}

export const getDynamicColorCss = (color: string): CSS => ({
  color
})
